<template>
  <v-row class="my-5" align="center" justify="center">
    <v-col align="center">
      <v-card class="card mb-5">
        <div class="my-5">
          <h2 translate>{{ $t(["Are you sure"]) }}</h2>
          <p class="px-5" translate>
            {{ $t(["Pending_Refund_Text"]) }}
          </p>
        </div>

        <v-row class="mb-5 px-3" justify="center" align="center">
          <v-btn
            class="btn-text mx-3 my-3"
            color="secondary"
            min-width="200px"
            x-large
            outlined
            translate
            @click="backToOrderStatusSummary()"
          >
            {{ $t(["Cancel"]) }}
          </v-btn>

          <v-btn
            class="btn-text mx-3 my-3"
            color="primary"
            min-width="200px"
            x-large
            translate
            @click="goToRefundRequest()"
          >
            {{ $t(["Continue"]) }}
          </v-btn>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PendingRefund",
  data: () => ({}),
  methods: {
    backToOrderStatusSummary() {
      let data = this.$route.params.data;

      this.$router.replace({
        name: "OrderStatusSummary",
        params: { data: data },
      });
    },
    goToRefundRequest() {
      let data = this.$route.params.data;

      this.$router.replace({
        name: "RequestRefund",
        params: { data: data },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
